
document.addEventListener("DOMContentLoaded", () => {
  requestAnimationFrame(() => {
    setTimeout(() => {
      const section = document.querySelector(".bubbles-section");
      const wrapper = section?.querySelector(".image-wrapper");
      const bubbles = section.querySelectorAll(".bubble");
      const textBlock = document.getElementById("text-block-2");

      if (!section || !wrapper || !bubbles.length) return;

      const useRandom = wrapper.dataset.randomize === "true";
      const allowRespawn = wrapper.dataset.respawn === "true";

      function resetBubble(bubble) {
        bubble.style.transition = 'none';
        bubble.style.top = '110%';
        bubble.style.opacity = 0;
        bubble.style.transform = 'none';
        bubble.classList.remove('popped');
      }

      function resetBubbles() {
        bubbles.forEach(resetBubble);
      }

      function animateBubbles() {
        const wrapperWidth = wrapper.offsetWidth;
        const wrapperHeight = wrapper.offsetHeight;
        const wrapperRect = wrapper.getBoundingClientRect();
        const textBlockRect = textBlock?.getBoundingClientRect();

        let blockTop = 0, blockBottom = 0, blockLeft = 0, blockRight = 0;
        if (textBlock && textBlockRect) {
          blockTop = textBlockRect.top - wrapperRect.top;
          blockBottom = textBlockRect.bottom - wrapperRect.top;
          blockLeft = textBlockRect.left - wrapperRect.left;
          blockRight = textBlockRect.right - wrapperRect.left;
        }

        bubbles.forEach((bubble, i) => {
          bubble.style.display = 'block';
          bubble.style.height = 'auto';
          bubble.style.position = 'absolute';
          bubble.style.zIndex = 10;

          const bubbleWidth = bubble.offsetWidth || 80;
          const bubbleHeight = bubble.offsetHeight || 80;

          let tries = 0;
          let randomX = 0;
          let topInPixels = 0;
          const maxX = Math.max(wrapperWidth - bubbleWidth - 20, 0);

          do {
            randomX = Math.random() * maxX;
            const topTargetPercent = Math.random() * 40 + 10;
            topInPixels = (topTargetPercent / 100) * wrapperHeight;

            tries++;
            if (tries > 20) break;
          } while (
            textBlock &&
            randomX + bubbleWidth > blockLeft &&
            randomX < blockRight &&
            topInPixels + bubbleHeight > blockTop &&
            topInPixels < blockBottom
          );

          const delay = Math.random() * 2 + 0.3;

          bubble.style.transition = `top 4s ease-out ${delay}s, opacity 1s ${delay}s`;
          bubble.style.left = `${randomX}px`;
          bubble.style.top = `${topInPixels}px`;
          bubble.style.opacity = 1;

          if (useRandom) {
            const scale = Math.random() * 0.6 + 0.7;
            const rotation = Math.random() * 360;
            const opacity = Math.random() * 0.5 + 0.5;
            bubble.style.transform = `scale(${scale}) rotate(${rotation}deg)`;
            bubble.style.opacity = opacity;
          }
        });
      }

      bubbles.forEach(bubble => {
        bubble.addEventListener("click", () => {
          const respawn = wrapper.dataset.respawn === "true";
          const computedTop = window.getComputedStyle(bubble).top;
          const computedLeft = window.getComputedStyle(bubble).left;
          const computedTransform = window.getComputedStyle(bubble).transform;

          bubble.style.transition = 'none';
          bubble.style.top = computedTop;
          bubble.style.left = computedLeft;
          bubble.style.transform = computedTransform;

          requestAnimationFrame(() => {
            bubble.classList.add("popped");
          });

          if (respawn) {
            setTimeout(() => {
              resetBubble(bubble);
              setTimeout(() => {
                animateBubbles();
              }, 500);
            }, 2000);
          }
        });
      });

      let hasAnimated = false;
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !hasAnimated) {
            hasAnimated = true;
            resetBubbles();
            setTimeout(animateBubbles, 100);
          }
        });
      }, { threshold: 0.4 });

      observer.observe(section);
    }, 300);
  });
});
